export default "__VITE_ASSET__BJF1KMpW__"